import { render, staticRenderFns } from "./EmployeeInfoTab.vue?vue&type=template&id=dceaed1e&scoped=true"
import script from "./EmployeeInfoTab.vue?vue&type=script&lang=js"
export * from "./EmployeeInfoTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dceaed1e",
  null
  
)

export default component.exports